import { render, staticRenderFns } from "./RdmLoading.vue?vue&type=template&id=1f5c2213&scoped=true&"
import script from "./RdmLoading.vue?vue&type=script&lang=ts&"
export * from "./RdmLoading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c2213",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VProgressCircular,VSnackbar})
